import { setLocalStorage, getLocalStorage } from '.';

export const searches = {
  last: {
    key: 'ldt.searches.last',
  },
};

export const location = {
  last: {
    key: 'ldt.location.last',
  },
};

export const recentEventVisits = {
  key: 'ldt.recentEventVisits',
  limit: 12,
};

export const recentBookings = {
  key: 'ldt.recentBookings',
};

export const guestBookingIds = {
  key: 'ldt.guestBookingIds',
};

export const ldtExperiments = {
  key: 'ldt.experiments',
};
export const guestContributionIds = {
  key: 'ldt.guestContributionIds',
};
export const hideRaceEntryInput = {
  key: 'ldt.hideRaceEntryInput',
};
/**
 * Used to store temp stars selection for review
 * */
export const reviewTemp = {
  key: 'ldt.reviewTemp',
};

/**
 * Used to store full review after creation, with creation context
 * */
export const reviewCreationData = {
  key: 'ldt.reviewCreationData',
};

/**
 * Coronavirus banner
 */
export const showCoronaVirusBanner = {
  key: 'ldt.showCoronaVirusBanner2',
};

/**
 * Virtual Events Info modal
 */
export const seenVirtualEventsModal = {
  key: 'ldt.seenVirtualEventsModal',
};

/**
 * Booking Progress
 */
export const bookingProgress = {
  key: 'ldt.bookingProgress',
};

/**
 * Feedback/NPS request timestamp
 */
export const feedbackSubmitted = {
  key: 'ldt.feedbackSubmitted',
};

/**
 * result submission notification timestamp
 */
export const resultSubmissionNotification = {
  key: 'ldt.resultSubmissionNotification',
};

/**
 * Bib Collection Progress
 */
export const bibCollectionProgress = {
  key: 'ldt.bibCollectionProgress',
};

export const setRecentEventVisits = (eventId) => {
  let recentlyViewedEvents = JSON.parse(getLocalStorage(recentEventVisits.key));
  if (recentlyViewedEvents && recentlyViewedEvents.length) {
    const indexOfSameEvent = recentlyViewedEvents.indexOf(eventId);
    if (indexOfSameEvent >= 0) {
      recentlyViewedEvents.splice(indexOfSameEvent, 1);
      recentlyViewedEvents = [eventId].concat(recentlyViewedEvents);
    } else {
      if (recentlyViewedEvents.length >= recentEventVisits.limit) {
        recentlyViewedEvents.splice(-1, 1);
      }
      recentlyViewedEvents = [eventId].concat(recentlyViewedEvents);
    }
  } else {
    recentlyViewedEvents = [eventId];
  }
  setLocalStorage(recentEventVisits.key, JSON.stringify(recentlyViewedEvents));
};

const ldt = {
  searches,
  recentEventVisits,
};

export default ldt;
